var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50977 11.2207V15.7107C3.50977 20.2007 5.30977 22.0007 9.79977 22.0007H15.1898C19.6798 22.0007 21.4798 20.2007 21.4798 15.7107V11.2207",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 12.0005C14.3305 12.0005 15.6805 10.5105 15.5005 8.68049L14.8405 2.00049H10.1705L9.50048 8.68049C9.32048 10.5105 10.6705 12.0005 12.5005 12.0005Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 12.0005C20.8308 12.0005 22.3108 10.3605 22.1108 8.35049L21.8308 5.60049C21.4708 3.00049 20.4708 2.00049 17.8508 2.00049H14.8008L15.5008 9.01049C15.6708 10.6605 17.1608 12.0005 18.8108 12.0005Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14037 12.0005C7.79037 12.0005 9.28037 10.6605 9.44037 9.01049L9.66037 6.80049L10.1404 2.00049H7.09037C4.47037 2.00049 3.47037 3.00049 3.11037 5.60049L2.84037 8.35049C2.64037 10.3605 4.12037 12.0005 6.14037 12.0005Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.0005C10.83 17.0005 10 17.8305 10 19.5005V22.0005H15V19.5005C15 17.8305 14.17 17.0005 12.5 17.0005Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.62e4284d39abb52a5d12c600b76ff569.svg";
export { ForwardRef as ReactComponent };